import React, { useState, useRef, useMemo, useEffect, forwardRef } from "react";
import Table from "react-bootstrap/Table";
import { dateFormat } from "../../utils";
import Pagination from "react-responsive-pagination";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faSpinner } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import TripPDF from "../pdfContent/TripPDF";
import MapComponent from "../MapComponent";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { Dialog } from "primereact/dialog";
import {
  DELETE_TRIP,
  DELETE_TRIP_V1,
  DELETE_TRIP_COMPLETELY_BY_SCHEDULE_ID,
  EDIT_TRIP_MILES,
} from "../../constant";
import axios from "axios";
//import Swal from 'sweetalert2/dist/sweetalert2';
import Swal from "../../messageBox/customSweetAlert";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/loaderAction";
import { Base64 } from "js-base64";
import { size } from "lodash";
import { color } from "framer-motion";
import LegDistanceCell from "../LegDistanceCell";

const TripTableLatest = forwardRef(
  (
    {
      tableData,
      onDeleteSuccess,
      setTableData,
      showAllRowsForExport,
      useScheduleTransIdForEditMiles = false,
      useTripsV1Delete = false,
      filterPayer,
      filterFromDate,
      filterToDate,
      filterDriver,
      filterPassenger,
      filterTripStatusStr,
    },
    ref
  ) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pdfRef = useRef();
    const handleEditClick = (id) => {
      navigate(`/home/schedule/edit/${id}`);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const totalPages = Math.ceil(tableData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    // const paginatedData = tableData.slice(startIndex, endIndex);
    const paginatedData = useMemo(() => {
      return tableData.slice(startIndex, endIndex);
    }, [tableData, startIndex, endIndex]);
    const [loadingRow, setLoadingRow] = useState(null);
    const [visible, setVisible] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [editMilesDialogVisible, setEditMilesDialogVisible] = useState(false);
    const [editMilesData, setEditMilesData] = useState({
      tripId: null,
      scheduleId: null,
      scheduleTransId: null,
      passengerId: null,
      miles: ""
    });
    const [savingMiles, setSavingMiles] = useState(false);
    useEffect(() => {
      setCurrentPage(1);
    }, [tableData]);
    const myArray = {};
    paginatedData.forEach((val) => {
      const schid = val.schedule_id;
      if (!myArray[schid]) {
        myArray[schid] = [];
      }
      // myArray[schid].push(val.transData);
      val.transData.forEach((trans) => {
        if (
          !myArray[schid].some(
            (item) => item.schedule_trans_id === trans.schedule_trans_id
          )
        ) {
          myArray[schid].push(trans);
        }
      });
    });
    //console.log("myArray",myArray);
    const uniquePaginatedData = paginatedData.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.schedule_id === item.schedule_id)
    );

    const [showModal, setShowModal] = useState(false);
    const [pdfDetails, setPdfDetails] = useState(null);

    const handlePdfClick = (details) => {
      localStorage.setItem("pdfDetails", JSON.stringify(details));
      localStorage.setItem("myArray", JSON.stringify(myArray));
      window.open("/home/pdf-preview", "_blank");
    };

    const handleMapIconClick = (trip) => {
      setSelectedTrip(trip);
      setVisible(true);
    };

    const openEditMilesDialog = (details, leg) => {
      // if (!leg?.trip?.trip_id) return;
      if (!details.schedule_id) return;

      const miles = leg.miles;
      const passengerId =
        details?.passengerDetails?.passengerId ??
        null;
      setEditMilesData({
        tripId: details.schedule_id,
        scheduleId: details.schedule_id,
        scheduleTransId: leg.schedule_trans_id,
        passengerId,
        miles: miles != null && miles !== "" ? String(miles) : "",
      });
      setEditMilesDialogVisible(true);
    };

    const handleEditMilesChange = (value) => {
      const numericValue = value.replace(/[^\d.]/g, "");
      setEditMilesData((prev) => ({ ...prev, miles: numericValue }));
    };

    const handleSaveMiles = async () => {
      const editTargetId = useScheduleTransIdForEditMiles
        ? editMilesData.scheduleTransId
        : editMilesData.tripId;
      if (!editTargetId) {
        setEditMilesDialogVisible(false);
        return;
      }
      if (!editMilesData.passengerId) {
        Swal.fire({
          title: "Error",
          text: "Passenger is missing for this trip.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const milesStr = (editMilesData.miles || "").trim();
      if (!milesStr) {
        Swal.fire({
          title: "Error",
          text: "Miles is required.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      const milesNum = parseFloat(milesStr);
      if (Number.isNaN(milesNum) || milesNum < 0) {
        Swal.fire({
          title: "Error",
          text: "Miles must be a valid number (0 or greater).",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      dispatch(setLoading(true));
      setSavingMiles(true);
      try {
        console.log('editMilesData', editMilesData);
        const response = await axios.patch(
          `${EDIT_TRIP_MILES}/${editTargetId}`,
          {
            miles: String(milesNum),
            passengerId: editMilesData.passengerId
          }
        );

        if (response?.data?.status === "200" || response?.data?.status === 200) {
          Swal.fire({
            title: "Success!",
            text:
              response?.data?.message || "Trip miles updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setEditMilesDialogVisible(false);

          if (setTableData) {
            setTableData((prevData) =>
              prevData.map((schedule) => {
                if (
                  String(schedule.schedule_id) !==
                  String(editMilesData.scheduleId)
                ) {
                  return schedule;
                }
                return {
                  ...schedule,
                  transData: (schedule.transData || []).map((legItem) => {
                    return {
                      ...legItem,
                      miles: milesNum,
                      trip: {
                        ...legItem.trip,
                        miles: milesNum,
                      },
                    };
                  }),
                };
              })
            );
          }
        } else {
          Swal.fire({
            title: "Error",
            text:
              response?.data?.message || "Failed to update trip miles.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Failed to update trip miles.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        dispatch(setLoading(false));
        setSavingMiles(false);
      }
    };

    const generatePDF = (details, index) => {
      setLoadingRow(index);
      setPdfDetails(details);
      setTimeout(() => {
        var input = pdfRef.current;
        if (input) {
          html2canvas(input, { useCORS: true, allowTaint: true }).then(
            (canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");
              const imgWidth = 210;
              const pageHeight = 297;
              const padding = 10;
              const contentWidth = imgWidth - padding * 2;
              const imgHeight = (canvas.height * contentWidth) / canvas.width;
              let heightLeft = imgHeight;
              let position = 0;

              pdf.addImage(
                imgData,
                "PNG",
                padding,
                position,
                contentWidth,
                imgHeight
              );
              heightLeft -= pageHeight;

              while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(
                  imgData,
                  "PNG",
                  padding,
                  position,
                  contentWidth,
                  imgHeight
                );
                heightLeft -= pageHeight;
              }
              pdf.save(`Trip_Details_${details.schedule_id}.pdf`);
              setLoadingRow(null);
            }
          );
        } else {
          console.error("pdfRef.current is null or undefined");
          setLoadingRow(null);
        }
      }, 1000);
    };

    const renderLegs = (legs, renderContent) => {
      return legs && legs.length > 0 ? (
        legs
          .flat()
          .filter(
            (leg, index, self) =>
              index ===
              self.findIndex(
                (l) =>
                  (l.trip?.pickup_location === leg.trip?.pickup_location &&
                    l.trip?.dropOffLocation === leg.trip?.dropOffLocation &&
                    l.trip?.pick_up_time === leg.trip?.pick_up_time &&
                    l.trip?.drop_off_time === leg.trip?.drop_off_time &&
                    l.trip?.startOdometer === leg.trip?.startOdometer &&
                    l.trip?.endOdometer === leg.trip?.endOdometer &&
                    l.trip?.miles === leg.trip?.miles) ||
                  // Allow match by miles only if miles is non-null
                  (l.trip?.miles != null &&
                    leg.trip?.miles != null &&
                    l.trip?.miles === leg.trip?.miles)
              )
          )
          .map((leg, legIndex) => (
            <div key={legIndex}>{renderContent(leg, legIndex)}</div>
          ))
      ) : (
        <div>No data available</div>
      );
    };
    const handleDeleteClick = (id, schedule_trans_id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(setLoading(true));
          axios
            .delete(`${DELETE_TRIP}/${id}/schedule/${schedule_trans_id}`)
            .then((response) => {
              if (response.data.status === 200) {
                dispatch(setLoading(false));
                uniquePaginatedData.filter((item) => item.trip?.trip_id != id);
                onDeleteSuccess(id);
              } else {
                dispatch(setLoading(false));
                toast.error(response.data.message, { position: "top-center" });
              }
              //console.log(response);
            })
            .catch((error) => {
              dispatch(setLoading(false));
              toast.error(error, { position: "top-center" });
            });
          //alert(userId);
        }
      });
    };
    const handleDeleteTrip = (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "This will permanently remove the trip from your history, billing, and reports. You won't be able to recover this information later.",
        // text: "Once deleted, this trip will be permanently removed from billing, reports, and the completed trips section. This action cannot be undone. Do you still want to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(setLoading(true));
          const deleteUrl = useTripsV1Delete
            ? `${DELETE_TRIP_V1}/${id}`
            : DELETE_TRIP_COMPLETELY_BY_SCHEDULE_ID + "/" + `${id}`;
          axios
            .delete(deleteUrl)
            .then((response) => {
              dispatch(setLoading(false));
              if (response.data.status === 200) {
                // Remove the schedule from the list without reloading
                if (setTableData) {
                  setTableData((prevData) => {
                    const filtered = prevData.filter(
                      (item) => String(item?.schedule_trans_id) !== String(id)
                    );
                    return filtered;
                  });
                }
                // Show success modal
                Swal.fire({
                  title: "Success!",
                  text: response.data.message || "Trip deleted successfully",
                  icon: "success",
                  confirmButtonText: "OK",
                });
                // Don't call onDeleteSuccess to avoid triggering a reload that would overwrite our update
                // The parent's handleDeleteSuccess triggers a refetch which would undo our local update
              } else {
                // Show error modal
                Swal.fire({
                  title: "Error!",
                  text: response.data.message || "Failed to delete trip",
                  icon: "error",
                  confirmButtonText: "OK",
                });
              }
            })
            .catch((error) => {
              dispatch(setLoading(false));
              // Show error modal
              Swal.fire({
                title: "Error!",
                text:
                  error?.response?.data?.message ||
                  error?.message ||
                  "An error occurred while deleting the trip",
                icon: "error",
                confirmButtonText: "OK",
              });
            });
        }
      });
    };

    const displayFromDate = filterFromDate
      ? moment(filterFromDate).format("MM/DD/YYYY")
      : "";
    const displayToDate = filterToDate
      ? moment(filterToDate).format("MM/DD/YYYY")
      : "";
    const displayPayer = filterPayer === "0" ? "All" : filterPayer;
    const displayDriver = filterDriver || "All";
    const displayPassenger = filterPassenger || "All";
    const displayStatus = filterTripStatusStr;

    return (
      <>
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            style={{ border: "2px solid rgba(224, 224, 224, 1)", minWidth: "100%" }}
            id="trip-table"
            border="2"
            bordered
            className="tbl-require table-schedule tripTable"
          >
            <thead>
              <tr>
                <th>Trip Date</th>
                <th>Passenger</th>
                <th>Driver</th>
                {/* <th>Vehicle</th> */}
                <th>Payer</th>
                <th>Pickup / Drop Off Details</th>
                <th title="Scheduled Miles">Sch. Miles</th>
                <th>Dead Head Miles</th>
                <th className="no-export no-pdf">Map</th>
                <th className="no-export no-pdf" style={{ textAlign: "center" }}>
                  Passenger Sign
                </th>
                <th className="no-export no-pdf" style={{ textAlign: "center" }}>
                  Driver Sign
                </th>
                <th className="no-export no-pdf">Trip Sheet</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {uniquePaginatedData && uniquePaginatedData.length > 0 ? (
                uniquePaginatedData.map((details, index) => {
                  const legs = myArray[details.schedule_id] || [];

                  const getDuration = (leg) => {
                    //console.log('duration', leg);
                    if (leg?.trip?.pick_up_time && leg?.trip?.drop_off_time) {
                      const start = moment(leg.trip.pick_up_time, "HH:mm:ss");
                      const end = moment(leg.trip.drop_off_time, "HH:mm:ss");
                      const diff = moment.duration(end.diff(start));
                      const hours = diff.hours();
                      const minutes = diff.minutes();
                      return hours > 0
                        ? `${hours} hr${hours > 1 ? "s" : ""} ${minutes > 0 ? `${minutes} min` : ""
                        }`
                        : `${minutes} min`;
                    }
                    return "";
                  };

                  if (legs.length === 0) {
                    return (
                      <tr key={index}>
                        <td colSpan="17" style={{ textAlign: "center" }}>
                          No legs available
                        </td>
                      </tr>
                    );
                  }

                  return legs.map((leg, legIndex) => {
                    return (
                      <tr
                        key={leg.schedule_trans_id}
                        className={
                          legIndex === legs.length - 1 ? "group-last-row" : ""
                        }
                      >
                        {legIndex === 0 && (
                          <>
                            {/* <td className="align-middle" rowSpan={legs.length}>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td> */}
                            <td className="align-middle" rowSpan={legs.length}>
                              {dateFormat(details?.trip?.tripDate) ?? ""}
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              <div
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <a
                                  href={`/home/passenger/profile/id?profilId=${Base64.encode(
                                    details.passengerDetails?.passengerId
                                  )}`} // Replace with the correct route
                                  target="_blank" // Open in a new tab
                                  onClick={() =>
                                    localStorage.setItem(
                                      "activeMenu",
                                      "Passenger List"
                                    )
                                  }
                                  rel="noopener noreferrer" // Security best practice
                                  style={{
                                    textDecoration: "none",
                                    color: "rgb(49, 135, 111)",
                                  }} // Inherit color and remove underline
                                >
                                  {details.passengerDetails
                                    ? `${details.passengerDetails
                                      ?.passengerFirstName || ""
                                    } ${details.passengerDetails
                                      ?.passengerMiddleName || ""
                                    } ${details.passengerDetails
                                      ?.passengerLastName || ""
                                    }`
                                    : ""}
                                </a>
                              </div>
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              <div
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <a
                                  href={
                                    details.driverDetails?.user_role == 2
                                      ? `/home/profile/myProfile`
                                      : `/home/driver/profile/id?profilId=${Base64.encode(
                                        details.driverDetails?.driverId
                                      )}`
                                  } // Replace with the correct route
                                  target="_blank" // Open in a new tab
                                  onClick={() =>
                                    localStorage.setItem(
                                      "activeMenu",
                                      "Driver List"
                                    )
                                  }
                                  rel="noopener noreferrer" // Security best practice
                                  style={{
                                    textDecoration: "none",
                                    color: "rgb(49, 135, 111)",
                                  }} // Inherit color and remove underline
                                >
                                  {details.driverDetails
                                    ? details.driverDetails?.firstName &&
                                      details.driverDetails?.lastName
                                      ? `${details.driverDetails.firstName} ${details.driverDetails?.middleName ?? ""
                                      } ${details.driverDetails.lastName}`
                                      : details.driverDetails?.fullName || "N/A"
                                    : "N/A"}
                                </a>
                              </div>
                            </td>
                            {/* <td className="align-middle" rowSpan={legs.length}>
                              {details?.trip?.vehicle?.vehicle_name || (
                                <span style={{ color: "#a9a9a9" }}>N/A</span>
                              )}
                            </td> */}
                            <td className="align-middle" rowSpan={legs.length}>
                              {
                                details.passengerDetails?.passenger?.payerDetails
                                  ?.payer_name
                              }
                            </td>

                          </>
                        )}

                        {/* Pickup / Drop Off Details */}
                        <td
                          style={
                            leg.trip?.no_show_flag == 1 || leg.no_show_flag == 1
                              ? { color: "#a9a9a9" }
                              : {}
                          }
                        >
                          <div
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              overflowX: "hidden",
                              padding: "5px",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              Leg {legIndex + 1}
                              {leg.trip?.no_show_flag == 1 ||
                                leg.no_show_flag == 1
                                ? " No show passenger"
                                : ""}
                            </span>{" "}
                            {/* <i
                              className="pi pi-trash icon-btn-delete float-end delete-icon cursor-pointer no-export no-pdf"
                              onClick={() =>
                                handleDeleteClick(
                                  leg.trip.trip_id,
                                  leg.schedule_trans_id
                                )
                              }
                              title="Delete Leg"
                            ></i> */}
                            <br />
                            {leg.trip?.no_show_flag != 1 &&
                              leg.no_show_flag != 1 && (
                                <>
                                  <div
                                    className="ellipsis"
                                    title={leg.trip?.pickup_location}
                                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                                  >
                                    <span
                                      style={{
                                        color: "#105c64",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Pickup:
                                    </span>{" "}
                                    {leg.trip?.pickup_location}
                                  </div>
                                  <br />
                                  <div
                                    className="ellipsis"
                                    title={leg.trip?.dropOffLocation}
                                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                                  >
                                    <span
                                      style={{
                                        color: "#105c64",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Drop Off:
                                    </span>{" "}
                                    {leg.trip?.dropOffLocation ? (
                                      leg.trip?.dropOffLocation
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        Trip in progress
                                      </span>
                                    )}
                                  </div>
                                  <br />
                                  <span
                                    style={{
                                      color: "#105c64",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Time:
                                  </span>{" "}
                                  {leg.trip?.pick_up_time
                                    ? moment(
                                      leg.trip?.pick_up_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm a")
                                    : ""}{" "}
                                  <i
                                    class="pi pi-arrow-right"
                                    style={{ fontSize: "11px" }}
                                  ></i>{" "}
                                  {leg.trip?.drop_off_time
                                    ? moment(
                                      leg.trip?.drop_off_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm a")
                                    : ""}
                                  {` ( ${getDuration(leg)} )`}
                                </>
                              )}
                          </div>
                        </td>
                        <td className="align-middle">
                          {leg?.miles ? (
                            Math.round(leg.miles)
                          ) : (
                            <LegDistanceCell
                              key={legIndex}
                              pickupLocId={leg.pick_up_location}
                              dropoffLocId={leg.drop_off_location}
                              legId={leg.schedule_trans_id}
                            />
                          )}
                          <>
                            {legIndex == 0 ? <i
                              className="pi pi-pen-to-square icon-btn-edit cursor-pointer"
                              title="Edit miles"
                              style={{ fontSize: "13px", marginLeft: "3px" }}
                              onClick={() => openEditMilesDialog(details, leg)}
                            >
                            </i> : null}
                          </>
                        </td>
                        <td className="align-middle">
                          {details?.dead_head_miles !== null && details?.dead_head_miles !== undefined
                            ? details.dead_head_miles
                            : <span style={{ color: "#a9a9a9" }}>N/A</span>}

                        </td>

                        <td className="align-middle no-export no-pdf">
                          {leg?.trip_status === 1 ? (
                            <div style={{ alignItems: "center" }}>
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                  fontSize: "15px",
                                }}
                                onClick={() => handleMapIconClick(leg)}
                              />
                            </div>
                          ) : (
                            <span style={{ color: "red" }}>No Map</span>
                          )}
                        </td>
                        {/* Signature Column */}
                        <td className="align-middle no-export no-pdf">
                          {leg?.signature_file ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/responses/uploads/${details.comp_id}/signature/passenger/${leg.schedule_trans_id}/${leg.signature_file}`}
                              alt={`Signature for Leg ${legIndex + 1}`}
                              style={{
                                width: "80px",
                                height: "50px",
                                objectFit: "contain",
                                margin: "5px",
                              }}
                            />
                          ) : leg?.signed_by === "0" ? (
                            <span className="refused-span">Refused to Sign</span>
                          ) : (
                            <span style={{ color: "red" }}>No Signature</span>
                          )}
                        </td>

                        <td className="align-middle no-export no-pdf">
                          {leg?.driver_signature_file ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/responses/uploads/${details.comp_id}/signature/driver/${leg.schedule_trans_id}/${leg?.driver_signature_file}`}
                              alt={`Signature for Leg ${legIndex + 1}`}
                              style={{
                                width: "80px",
                                height: "50px",
                                objectFit: "contain",
                                margin: "5px",
                              }}
                            />
                          ) : leg?.signed_by === "0" ? (
                            <span className="refused-span">Refused to Sign</span>
                          ) : (
                            <span style={{ color: "red" }}>No Signature</span>
                          )}
                        </td>
                        {/* Bill Amount Only Once */}
                        {legIndex === 0 && (
                          <>
                            <td
                              className="align-middle no-export no-pdf"
                              rowSpan={legs.length}
                            >
                              <div
                                onClick={() => generatePDF(details, index)}
                                style={{
                                  color: "#ffffff",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {loadingRow === index ? (
                                  <FontAwesomeIcon
                                    icon={faSpinner}
                                    spin
                                    style={{
                                      marginRight: "5px",
                                      color: "#dd0f0f",
                                      fontSize: "17px",
                                    }}
                                    className="fa-2x"
                                  />
                                ) : (
                                  // <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px', backgroundColor: '#dd0f0f' }} className="fa-2x" />
                                  // <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px', color: '#dd0f0f',fontSize:'17px' }} className="fa-2x" />
                                  <i
                                    class="pi pi-file-pdf"
                                    style={{ color: "red", fontSize: "18px" }}
                                  ></i>
                                )}
                              </div>
                            </td>
                            <td className="align-middle">
                              <i
                                className="pi pi-trash icon-btn-delete delete-icon cursor-pointer no-export no-pdf"
                                onClick={() =>
                                  handleDeleteTrip(
                                    useTripsV1Delete
                                      ? leg.schedule_trans_id
                                      : details.schedule_id
                                  )
                                }
                                title="Delete Trip"
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              ></i>
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  });
                })
              ) : (
                <tr>
                  <td className="align-middle text-align" colSpan="15">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <Pagination
          current={currentPage}
          total={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={50}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
        {pdfDetails && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              overflow: "hidden",
              top: "-9999px",
              left: "-9999px",
            }}
          >
            <TripPDF ref={pdfRef} details={pdfDetails} myArray={myArray} />
          </div>
        )}

        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            top: "-9999px",
            left: "-9999px",
          }}
        >
          <Table
            ref={ref}
            style={{ border: "2px solid rgba(224, 224, 224, 1)" }}
            border="2"
            bordered
            className="tbl-require table-schedule tripTable"
          >
            <thead>
              <tr>
                <td
                  colSpan={15}
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "13px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  {`TRIP LIST : Date: ${displayFromDate} to ${displayToDate} | Payer: ${displayPayer} | Driver: ${displayDriver} | Passenger: ${displayPassenger} | Status: ${displayStatus}`}
                </td>
              </tr>
              <tr>
                <th>#</th>
                <th>Trip Date</th>
                <th>Passenger</th>
                <th>Driver</th>
                <th>Vehicle</th>
                <th>Payer</th>
                <th>Dead Head Miles</th>
                <th>Pickup / Drop Off Details</th>
                <th>Odometer</th>
                <th title="Scheduled Miles">Sch. Miles</th>
                <th>Miles Traveled</th>
                {/* <th>Duration</th> */}
                <th className="no-export no-pdf">Map</th>
                <th
                  className="no-export no-pdf"
                  style={{ textAlign: "center" }}
                >
                  Sign
                </th>
                {/* <th>Bill Amount</th> */}
                <th className="no-export no-pdf">Trip Sheet</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {uniquePaginatedData && uniquePaginatedData.length > 0 ? (
                uniquePaginatedData.map((details, index) => {
                  const legs = myArray[details.schedule_id] || [];

                  const getDuration = (leg) => {
                    //console.log('duration', leg);
                    if (leg?.trip?.pick_up_time && leg?.trip?.drop_off_time) {
                      const start = moment(leg.trip.pick_up_time, "HH:mm:ss");
                      const end = moment(leg.trip.drop_off_time, "HH:mm:ss");
                      const diff = moment.duration(end.diff(start));
                      const hours = diff.hours();
                      const minutes = diff.minutes();
                      return hours > 0
                        ? `${hours} hr${hours > 1 ? "s" : ""} ${minutes > 0 ? `${minutes} min` : ""
                        }`
                        : `${minutes} min`;
                    }
                    return "";
                  };

                  if (legs.length === 0) {
                    return (
                      <tr key={index}>
                        <td colSpan="17" style={{ textAlign: "center" }}>
                          No legs available
                        </td>
                      </tr>
                    );
                  }

                  return legs.map((leg, legIndex) => {
                    //console.log('Leg data:', leg, 'no_show_flag:', leg.no_show_flag, 'trip.no_show_flag:', leg.trip?.no_show_flag);
                    return (
                      <tr
                        key={legIndex}
                        className={[
                          legIndex === legs.length - 1 ? "group-last-row" : "",
                          "avoid-break",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      >
                        {legIndex === 0 && (
                          <>
                            <td className="align-middle" rowSpan={legs.length}>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              {dateFormat(details?.trip?.tripDate) ?? ""}
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <a
                                  href={`/home/passenger/profile/id?profilId=${Base64.encode(
                                    details.passengerDetails?.passengerId
                                  )}`} // Replace with the correct route
                                  target="_blank" // Open in a new tab
                                  onClick={() =>
                                    localStorage.setItem(
                                      "activeMenu",
                                      "Passenger List"
                                    )
                                  }
                                  rel="noopener noreferrer" // Security best practice
                                  style={{
                                    textDecoration: "none",
                                    color: "rgb(49, 135, 111)",
                                  }} // Inherit color and remove underline
                                >
                                  {details.passengerDetails
                                    ? `${details.passengerDetails
                                      ?.passengerFirstName || ""
                                    } ${details.passengerDetails
                                      ?.passengerMiddleName || ""
                                    } ${details.passengerDetails
                                      ?.passengerLastName || ""
                                    }`
                                    : ""}
                                </a>
                              </div>
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <a
                                  href={`/home/driver/profile/id?profilId=${Base64.encode(
                                    details.driverDetails?.driverId
                                  )}`} // Replace with the correct route
                                  target="_blank" // Open in a new tab
                                  onClick={() =>
                                    localStorage.setItem(
                                      "activeMenu",
                                      "Driver List"
                                    )
                                  }
                                  rel="noopener noreferrer" // Security best practice
                                  style={{
                                    textDecoration: "none",
                                    color: "rgb(49, 135, 111)",
                                  }} // Inherit color and remove underline
                                >
                                  {details.driverDetails
                                    ? details.driverDetails?.firstName &&
                                      details.driverDetails?.lastName
                                      ? `${details.driverDetails.firstName} ${details.driverDetails?.middleName ??
                                        ""
                                        } ${details.driverDetails.lastName
                                        }`.trim()
                                      : details.driverDetails?.full_name || ""
                                    : ""}
                                </a>
                              </div>
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              {details?.trip?.vehicle?.vehicle_name || (
                                <span style={{ color: "#a9a9a9" }}>N/A</span>
                              )}
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              {
                                details.passengerDetails?.passenger
                                  ?.payerDetails?.payer_name
                              }
                            </td>
                            <td className="align-middle" rowSpan={legs.length}>
                              {details?.dead_head_miles !== null && details?.dead_head_miles !== undefined
                                ? details.dead_head_miles
                                : <span style={{ color: "#a9a9a9" }}>N/A</span>}
                            </td>
                          </>
                        )}

                        {/* Pickup / Drop Off Details */}
                        <td
                          style={
                            leg.trip?.no_show_flag == 1 || leg.no_show_flag == 1
                              ? { color: "#a9a9a9" }
                              : {}
                          }
                        >
                          <div
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              overflowX: "hidden",
                              padding: "5px",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              Leg {legIndex + 1}
                              {leg.trip?.no_show_flag == 1 ||
                                leg.no_show_flag == 1
                                ? " No show passenger"
                                : ""}
                            </span>{" "}
                            <i
                              className="pi pi-trash icon-btn-delete float-end delete-icon cursor-pointer no-export no-pdf"
                              onClick={() =>
                                handleDeleteClick(leg.trip.trip_id)
                              }
                              title="Delete Leg"
                            ></i>
                            <br />
                            {leg.trip?.no_show_flag != 1 &&
                              leg.no_show_flag != 1 && (
                                <>
                                  <div
                                    className="ellipsis"
                                    title={leg.trip?.pickup_location}
                                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                                  >
                                    <span
                                      style={{
                                        color: "#105c64",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Pickup:
                                    </span>{" "}
                                    {leg.trip?.pickup_location}
                                  </div>
                                  <br />
                                  <div
                                    className="ellipsis"
                                    title={leg.trip?.dropOffLocation}
                                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                                  >
                                    <span
                                      style={{
                                        color: "#105c64",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Drop Off:
                                    </span>{" "}
                                    {leg.trip?.dropOffLocation ? (
                                      leg.trip?.dropOffLocation
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        Trip in progress
                                      </span>
                                    )}
                                  </div>
                                  <br />
                                  <span
                                    style={{
                                      color: "#105c64",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Time:
                                  </span>{" "}
                                  {leg.trip?.pick_up_time
                                    ? moment(
                                      leg.trip?.pick_up_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm a")
                                    : ""}{" "}
                                  <i
                                    class="pi pi-arrow-right"
                                    style={{ fontSize: "11px" }}
                                  ></i>{" "}
                                  {leg.trip?.drop_off_time
                                    ? moment(
                                      leg.trip?.drop_off_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm a")
                                    : ""}
                                  {` ( ${getDuration(leg)} )`}
                                </>
                              )}
                          </div>
                        </td>

                        {/* Odometer Column */}

                        <td className="align-middle">
                          {leg.trip?.no_show_flag == 1 ||
                            leg.no_show_flag == 1 ? (
                            <span style={{ color: "#a9a9a9" }}>N/A</span>
                          ) : (
                            <div>
                              <i
                                title="Odometer Start"
                                class="pi pi-flag greenflag"
                              ></i>{" "}
                              {leg.trip?.startOdometer}
                              <br />
                              <i
                                title="Odometer End"
                                class="pi pi-flag redflag"
                              ></i>{" "}
                              {leg.trip?.endOdometer}
                            </div>
                          )}
                        </td>
                        {/* Miles Column */}
                        <td className="align-middle">
                          {leg?.miles ? (
                            Math.round(leg.miles)
                          ) : (
                            <LegDistanceCell
                              key={legIndex}
                              pickupLocId={leg.pick_up_location}
                              dropoffLocId={leg.drop_off_location}
                              legId={leg.schedule_trans_id}
                            />
                          )}
                        </td>
                        {/* total miles Column: Leg 1 = miles + dead_head_miles, Leg 2+ = miles only */}
                        <td className="align-middle">
                          {(() => {
                            const legMiles = leg?.trip?.miles ?? 0;
                            const deadHead = legIndex === 0 ? (details?.dead_head_miles ?? 0) : 0;
                            const total = legMiles + deadHead;
                            return total > 0 ? Math.round(total) : (
                              <span style={{ color: "red" }}>No Miles</span>
                            );
                          })()}
                        </td>
                        {/* <td className="align-middle">
    {getDuration(leg)}
</td> */}
                        <td className="align-middle no-export no-pdf">
                          {leg?.trip_status === 1 ? (
                            <div style={{ alignItems: "center" }}>
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                  fontSize: "15px",
                                }}
                                onClick={() => handleMapIconClick(leg)}
                              />
                            </div>
                          ) : (
                            <span style={{ color: "red" }}>No Map</span>
                          )}
                        </td>
                        {/* Signature Column */}
                        <td className="align-middle no-export no-pdf">
                          {leg?.signature_file ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/responses/uploads/${details.comp_id}/signature/${leg.schedule_trans_id}/${leg.signature_file}`}
                              alt={`Signature for Leg ${legIndex + 1}`}
                              style={{
                                width: "80px",
                                height: "50px",
                                objectFit: "contain",
                                margin: "5px",
                              }}
                            />
                          ) : leg?.signed_by === "0" ? (
                            <span className="refused-span">
                              Refused to Sign
                            </span>
                          ) : (
                            <span style={{ color: "red" }}>No Signature</span>
                          )}
                        </td>
                        {/* Bill Amount Only Once */}
                        {legIndex === 0 && (
                          <>
                            {/* <td className="align-middle" rowSpan={legs.length}>
                      {"$" + details?.bill_amount}
                    </td> */}
                            <td
                              className="align-middle no-export no-pdf"
                              rowSpan={legs.length}
                            >
                              <div
                                onClick={() => generatePDF(details, index)}
                                style={{
                                  color: "#ffffff",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {loadingRow === index ? (
                                  <FontAwesomeIcon
                                    icon={faSpinner}
                                    spin
                                    style={{
                                      marginRight: "5px",
                                      color: "#dd0f0f",
                                      fontSize: "17px",
                                    }}
                                    className="fa-2x"
                                  />
                                ) : (
                                  // <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px', backgroundColor: '#dd0f0f' }} className="fa-2x" />
                                  // <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: '5px', color: '#dd0f0f',fontSize:'17px' }} className="fa-2x" />
                                  <i
                                    class="pi pi-file-pdf"
                                    style={{ color: "red", fontSize: "18px" }}
                                  ></i>
                                )}
                              </div>
                            </td>
                            {/* <td className="align-middle" rowSpan={legs.length}></td> */}
                          </>
                        )}
                      </tr>
                    );
                  });
                })
              ) : (
                <tr>
                  <td className="align-middle text-align" colSpan="16">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {editMilesDialogVisible && (
          <Dialog
            visible={editMilesDialogVisible}
            header="Edit Miles Traveled"
            onHide={() => setEditMilesDialogVisible(false)}
            style={{ width: "30rem" }}
          >
            <div className="p-fluid">
              <div className="mb-3">
                <label className="form-label">Miles</label>
                <input
                  type="text"
                  className="form-control"
                  value={editMilesData.miles ?? ""}
                  onChange={(e) => handleEditMilesChange(e.target.value)}
                  placeholder="Enter miles"
                  inputMode="numeric"
                />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => setEditMilesDialogVisible(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSaveMiles}
                  disabled={savingMiles}
                >
                  {savingMiles ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        style={{ marginRight: "4px" }}
                      />
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </Dialog>
        )}

        {selectedTrip && (
          <Dialog
            visible={visible}
            header="Map"
            onHide={() => setVisible(false)}
            style={{ width: "50rem" }}
          >
            <MapComponent location={selectedTrip} />
          </Dialog>
        )}
      </>
    );
  }
);

export default TripTableLatest;
